module.exports = __webpack_public_path__ + "static/media/loader-ind.9756046d.gif";